import { render } from "./DHSchema.vue?vue&type=template&id=38c1cb6c&scoped=true"
import script from "./DHSchema.vue?vue&type=script&lang=js"
export * from "./DHSchema.vue?vue&type=script&lang=js"

import "./DHSchema.vue?vue&type=style&index=0&id=38c1cb6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c1cb6c"]])

export default __exports__